export default {
  label: 'CPF',
  hint: 'Your bank needs your CPF for this payment. We pass it on and don’t keep it.',
  invalid: 'That isn’t a valid CPF. Check the 11 digits.',
};
